import { Hex, slice } from "viem"

import { CommonErrorsKey } from "@eulerxyz/core-sdk"
import EVCErrors from "./errors/evc-errors.json"
import EVKErrors from "./errors/evk-errors.json"
import GenericErrors from "./errors/generic-errors.json"

const AllErrors: Record<Hex, string> = {
  ...EVCErrors,
  ...EVKErrors,
  ...GenericErrors,
}

export default function decodeUnknownErrors(data: Hex) {
  const signature = slice(data, 0, 4)

  if (AllErrors[signature]) {
    return AllErrors[signature]
  }
  console.error("[decodeUnknownErrors] Unknown error signature: ", signature)
  return CommonErrorsKey.UnknownError
}
